import axios from "axios";
// import CryptoJS from 'crypto-js';
import GlobalConfig from '../../src/globalConfig/globalConfig';

export const serialize = (obj) => {
  const str = [];
  Object.keys(obj).forEach(p => {
    str.push(`${encodeURIComponent(p)}=${encodeURIComponent(obj[p])}`);
  });
  /*for (const p in obj) {
    if (obj.hasOwnProperty(p)) {
      str.push(`${encodeURIComponent(p)}=${encodeURIComponent(obj[p])}`);
    }
  }*/
  return str.join('&');
};

export const replaceStringWithParams = (str, obj) => {
  Object.keys(obj).forEach(j => {
    const regExp = new RegExp(j, 'g');
    str = str.replace(regExp, obj[j]);
  });
  /*for (const j in obj) {
    const regExp = new RegExp(j, 'g');
    str = str.replace(regExp, obj[j]);
  }*/
  return str;
};

export const isAPICanceled = (e) => {
  if(axios.isCancel(e)){
    return false;
  }
};

export const setLocalStorage = (key, value) =>{
  localStorage.setItem(key, btoa(JSON.stringify( value)));
}

export const getLocalStorage = (key) =>{
  const localStorageData = localStorage.getItem(key) && JSON.parse(atob(localStorage.getItem(key)))
  return localStorageData;
}
export const setSession = (key, value) => {
  window.sessionStorage.setItem(key, btoa(JSON.stringify(value)));
};
export const getSession = (key) => {
    const data = window.sessionStorage.getItem(key);
    if (data) {
      return JSON.parse(atob(data));
    }
  
};
export const sortBoxData = boxList => {
  const primaryList = boxList.filter(f => f.connectionType === 'Primary');
  const secondaryList = boxList.filter(f => f.connectionType === 'Secondary').sort((a, b) => parseInt(a.subscriberId) - parseInt(b.subscriberId));
  const noConnectionTypeList = boxList.filter(f => f.connectionType === '');
  Array.isArray(primaryList) && primaryList.forEach(item => {
    const index = secondaryList.findIndex(i => i.subscriberId === item.subscriberId)
    if (index < 0)
      secondaryList.splice(0, 0, item)
    else
      secondaryList.splice(index, 0, item)
  })

  return secondaryList.concat(noConnectionTypeList)
}


export const interceptedData = async (encryptedBase64) => {
  const keyBytes = new Uint8Array([
    86, 76, 104, 52, 115, 101, 117, 86,
    101, 69, 75, 76, 77, 78, 79, 80,
  ]);

  const binaryStr = atob(encryptedBase64);
  const allBytes = new Uint8Array(binaryStr.length);
  for (let i = 0; i < binaryStr.length; i++) {
    allBytes[i] = binaryStr.charCodeAt(i);
  }

  const ivLength = 12;
  const iv = allBytes.slice(0, ivLength);
  const ciphertextWithTag = allBytes.slice(ivLength);

  return crypto.subtle.importKey(
    "raw",
    keyBytes,
    { name: "AES-GCM" },
    false,
    ["decrypt"]
  ).then((cryptoKey) =>
    crypto.subtle.decrypt(
      {
        name: "AES-GCM",
        iv: iv,
        tagLength: 128,
      },
      cryptoKey,
      ciphertextWithTag
    )
  ).then((decryptedBuffer) => {
    const decoded = new TextDecoder().decode(decryptedBuffer);
    try {
      console.log("decodedKey",decoded);
      return JSON.parse(decoded); 
    } catch {
      return decoded;
    }
  }).catch((error) => {
    console.error("Decryption failed:", error);
    return null;
  });
};

export const aesEncrypt = async(value) => {
    const keyBytes = new Uint8Array([
    86, 76, 104, 52, 115, 101, 117, 86,
    101, 69, 75, 76, 77, 78, 79, 80
  ]);

  const iv = crypto.getRandomValues(new Uint8Array(12)); // 12-byte IV
  const cryptoKey = await crypto.subtle.importKey(
    "raw",
    keyBytes,
    { name: "AES-GCM" },
    false,
    ["encrypt"]
  );

  const encodedText = new TextEncoder().encode(value);
  const encryptedBuffer = await crypto.subtle.encrypt(
    {
      name: "AES-GCM",
      iv: iv,
      tagLength: 128,
    },
    cryptoKey,
    encodedText
  );

  // Combine IV and ciphertext
  const combined = new Uint8Array(iv.length + encryptedBuffer.byteLength);
  combined.set(iv);
  combined.set(new Uint8Array(encryptedBuffer), iv.length);

  return btoa(String.fromCharCode(...combined));

};

export const addNoIndexOnPage = (nameVal, contentVal) => {
  if (!GlobalConfig.isServer()) {
    const link = document.createElement('META');
    link.setAttribute('NAME', nameVal);
    link.setAttribute('CONTENT', contentVal);
    document.head.appendChild(link);
  }
};